import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsParagraphComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-page-not-found-paragraph',
    templateUrl: './page-not-found-paragraph.component.html',
    styleUrl: './page-not-found-paragraph.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PageNotFoundParagraphComponent implements OnInit {

  public data$: Observable<CmsParagraphComponent>;

  constructor(public component: CmsComponentData<CmsParagraphComponent>) { }

  ngOnInit(): void {
    this.data$ = this.component.data$;
  }
}
